import React from 'react';
import './Loader.scss'

export default () => <div className="loaderWrapper"> <div className="loader"></div>    </div>
